export default function Reducer(state, action) {
  switch (action.type) {
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
